"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeatureFlagProvider = void 0;
var tslib_1 = require("tslib");
var config_hopin_constants_1 = require("@hopin-team/config-hopin-constants");
var react_1 = tslib_1.__importStar(require("react"));
var FeatureFlagContext_1 = require("./FeatureFlagContext");
var launchDarkly_1 = require("./lib/launchDarkly");
var FeatureFlagProvider = function (_a) {
    var _b = _a.loadMethod, loadMethod = _b === void 0 ? 'async' : _b, defaultFlags = _a.defaultFlags, flagScopes = _a.flagScopes, children = _a.children;
    var Provider = FeatureFlagContext_1.FeatureFlagContext.Provider;
    var _c = tslib_1.__read((0, react_1.useState)(tslib_1.__assign({}, defaultFlags)), 2), flags = _c[0], setFlags = _c[1];
    var _d = tslib_1.__read((0, react_1.useState)(true), 2), isInitial = _d[0], setIsInitial = _d[1];
    var _e = tslib_1.__read((0, react_1.useState)(false), 2), isLoading = _e[0], setIsLoading = _e[1];
    var _f = tslib_1.__read((0, react_1.useState)(false), 2), isLoaded = _f[0], setIsLoaded = _f[1];
    var _g = tslib_1.__read((0, react_1.useState)(false), 2), willUpdate = _g[0], setWillUpdate = _g[1];
    var _h = tslib_1.__read((0, react_1.useState)(undefined), 2), ldClient = _h[0], setLdClient = _h[1];
    var ldIndex = flagScopes === null || flagScopes === void 0 ? void 0 : flagScopes.findIndex(function (_a) {
        var type = _a.type;
        return type === 'launchDarkly';
    });
    if (!flagScopes || (flagScopes === null || flagScopes === void 0 ? void 0 : flagScopes.length) === 0) {
        throw new Error('You need to provide at least one flag scopes in the flagScopes object');
    }
    (0, react_1.useEffect)(function () {
        var _a;
        if (ldIndex !== -1) {
            var _b = flagScopes[ldIndex], options = _b.options, context = _b.context, clientId = _b.clientId;
            var clientSideID = ((_a = window === null || window === void 0 ? void 0 : window.hopin) === null || _a === void 0 ? void 0 : _a.LAUNCH_DARKLY_CLIENT_ID) ||
                clientId ||
                config_hopin_constants_1.LAUNCH_DARKLY_CLIENT_IDS.production;
            setIsLoading(true);
            setWillUpdate(true);
            (0, launchDarkly_1.ldInit)({
                clientSideID: clientSideID,
                options: options,
                context: context,
                loadMethod: loadMethod,
                setLdClient: setLdClient,
                setFlags: setFlags,
                setIsInitial: setIsInitial,
                setIsLoading: setIsLoading,
            });
        }
        setIsLoaded(true); //assume has now loaded all above scopes
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var value = (0, react_1.useMemo)(function () { return ({
        flags: flags,
        identifyUser: function (_a) {
            var key = _a.key, custom = _a.custom;
            return tslib_1.__awaiter(void 0, void 0, void 0, function () {
                return tslib_1.__generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            if (!ldClient) return [3 /*break*/, 2];
                            return [4 /*yield*/, (0, launchDarkly_1.ldIdentify)({ ldClient: ldClient, key: key, custom: custom })];
                        case 1:
                            _b.sent();
                            _b.label = 2;
                        case 2: return [2 /*return*/];
                    }
                });
            });
        },
        loadScope: function () {
            // TODO(csi-lk)
            throw new Error("not yet implemented, please update '@hopin-team/provider-feature-flag' when available");
        },
        isInitial: isInitial,
        isLoaded: isLoaded,
        isLoading: isLoading,
        hasError: false,
        willUpdate: willUpdate,
    }); }, [flags, isInitial, isLoaded, isLoading, ldClient, willUpdate]);
    return react_1.default.createElement(Provider, { value: value }, children);
};
exports.FeatureFlagProvider = FeatureFlagProvider;
exports.FeatureFlagProvider.displayName = 'FeatureFlagProvider';
//# sourceMappingURL=FeatureFlagProvider.js.map